import { Check } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/api";

const STEPS = [
  { key: "paid", label: "Paid", at: "paid_at" },
  { key: "packed", label: "Packed", at: null },
  { key: "dispatched", label: "Dispatched", at: "dispatched_at" },
  { key: "delivered", label: "Delivered", at: "delivered_at" },
];
const ORDER = ["pending", "paid", "packed", "dispatched", "delivered"];

export function StatusTimeline({ order }) {
  const idx = ORDER.indexOf(order.status);
  return (
    <ol className="grid grid-cols-4 gap-2" data-testid="order-status-timeline">
      {STEPS.map((s, i) => {
        const done = idx >= i + 1;
        const current = idx === i + 1;
        return (
          <li key={s.key} className="relative">
            <div className={`h-1 rounded-full ${done ? "bg-accent" : "bg-secondary"}`} />
            <div className="mt-3 flex items-center gap-1.5">
              <span className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] ${done ? "bg-accent text-white" : "bg-secondary text-muted-foreground"}`}>
                {done ? <Check weight="bold" size={11} /> : i + 1}
              </span>
              <span className={`text-xs font-semibold ${current ? "text-accent" : done ? "text-foreground" : "text-muted-foreground"}`}>{s.label}</span>
            </div>
            {s.at && order[s.at] && <p className="mt-1 text-[11px] text-muted-foreground">{fmtDate(order[s.at])}</p>}
          </li>
        );
      })}
    </ol>
  );
}
